import React from 'react'
import { GetServerSideProps } from 'next'
import Head from 'next/head'
import { SitemapPage } from '../../features/Sitemap'
import { getBlogsMeta } from 'utils/getBlogsMeta'

export default function Sitemap({
  specificPost,
}: {
  specificPost: { postTitle: string; postUrl: string }[]
}) {
  return (
    <div>
      <Head>
        <title>Sitemap</title>
        <meta name="title" content="Sitemap" />
        <meta name="description" content="Sitemap" />
        <link rel="canonical" href="https://wefeedraw.com/sitemap" />
      </Head>

      <main>
        <SitemapPage specificPost={specificPost} />
      </main>
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const slug = ctx.query.id

  const specificPost = await getBlogsMeta(slug)

  return {
    props: {
      specificPost,
    },
  }
}
